import React from 'react';

export default function AddTask() {
  return (
    <svg
      width="89"
      height="89"
      viewBox="0 0 89 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.5" cx="44.5" cy="44.5001" r="39.6977" fill="white" />
      <path
        opacity="0.4"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M48.797 60.3179L55.4108 65.9297L53.4698 68.2172L48.9896 64.4157L45.3318 68.1636L41.016 64.4147L37.2557 68.1627L33.0425 64.414L29.1797 68.1621L25.0691 64.4136L21.1037 68.1619L17.0958 64.4135L12.962 68.2225L10.9291 66.0163L17.111 60.3201L21.0928 64.0441L25.0325 60.32L29.1159 64.0439L32.9541 60.3196L37.139 64.0433L40.8756 60.3189L45.1621 64.0424L48.797 60.3179Z"
        fill="#DDDBF9"
      />
      <path
        opacity="0.21"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M59.7923 25.2999L43.7312 19.1795L44.4434 17.3106L60.5045 23.431L59.0477 16.8259C58.7064 15.2788 60.2138 13.9681 61.6985 14.5208L76.4971 20.0303L75.7993 21.9046L61.0007 16.3951L62.4575 23.0002C62.8003 24.5541 61.2792 25.8665 59.7923 25.2999Z"
        fill="#B5B3C5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.5 55.1433C50.3781 55.1433 55.1433 50.3781 55.1433 44.5C55.1433 38.6219 50.3781 33.8567 44.5 33.8567C38.6219 33.8567 33.8567 38.6219 33.8567 44.5C33.8567 50.3781 38.6219 55.1433 44.5 55.1433ZM44.5 57.8245C51.8589 57.8245 57.8245 51.8589 57.8245 44.5C57.8245 37.1411 51.8589 31.1755 44.5 31.1755C37.1411 31.1755 31.1755 37.1411 31.1755 44.5C31.1755 51.8589 37.1411 57.8245 44.5 57.8245Z"
        fill="#7F77D9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M51.9191 39.3986C52.4427 39.9221 52.4427 40.7709 51.9191 41.2945L43.6122 49.6014C43.0886 50.125 42.2398 50.125 41.7163 49.6014L37.0809 44.9661C36.5573 44.4425 36.5573 43.5937 37.0809 43.0701C37.6044 42.5466 38.4533 42.5466 38.9768 43.0701L42.6642 46.7575L50.0232 39.3986C50.5467 38.875 51.3956 38.875 51.9191 39.3986Z"
        fill="#7F77D9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.5 8C24.3416 8 8 24.3416 8 44.5C8 64.6584 24.3416 81 44.5 81C64.6584 81 81 64.6584 81 44.5C81 24.3416 64.6584 8 44.5 8ZM5 44.5C5 22.6848 22.6848 5 44.5 5C66.3152 5 84 22.6848 84 44.5C84 66.3152 66.3152 84 44.5 84C22.6848 84 5 66.3152 5 44.5Z"
        fill="#A7A5BA"
      />
      <g opacity="0.3">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.3105 40.0042C16.5867 40.0042 16.8105 40.228 16.8105 40.5042L16.8105 44.4999C16.8105 44.7761 16.5867 44.9999 16.3105 44.9999C16.0344 44.9999 15.8105 44.7761 15.8105 44.4999L15.8105 40.5042C15.8105 40.228 16.0344 40.0042 16.3105 40.0042Z"
          fill="#B5B3C5"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.8084 42.502C18.8084 42.7781 18.5846 43.002 18.3084 43.002L14.3126 43.002C14.0365 43.002 13.8126 42.7781 13.8126 42.502C13.8126 42.2258 14.0365 42.002 14.3126 42.002L18.3084 42.002C18.5846 42.002 18.8084 42.2258 18.8084 42.502Z"
          fill="#B5B3C5"
        />
      </g>
      <path
        opacity="0.6"
        d="M66.1495 53.282L67.2737 56.7003L70.692 57.8245L67.2737 58.9487L66.1495 62.3669L65.0253 58.9487L61.6071 57.8245L65.0253 56.7003L66.1495 53.282Z"
        fill="#B5B3C5"
      />
      <path
        opacity="0.34"
        d="M36.6882 22.324L37.312 24.2207L39.2087 24.8445L37.312 25.4682L36.6882 27.3649L36.0644 25.4682L34.1677 24.8445L36.0644 24.2207L36.6882 22.324Z"
        fill="#B5B3C5"
      />
      <path
        opacity="0.6"
        d="M65.2203 24.8445L66.0038 27.2266L68.3859 28.01L66.0038 28.7934L65.2203 31.1755L64.4369 28.7934L62.0548 28.01L64.4369 27.2266L65.2203 24.8445Z"
        fill="#BBB6F2"
      />
      <path
        d="M72.8995 40.5042C72.8995 41.1137 72.4054 41.6079 71.7958 41.6079C71.1862 41.6079 70.692 41.1137 70.692 40.5042C70.692 39.8946 71.1862 39.4004 71.7958 39.4004C72.4054 39.4004 72.8995 39.8946 72.8995 40.5042Z"
        fill="#D9D9D9"
      />
      <path
        d="M36.6882 75.8684C36.6882 76.478 36.1941 76.9722 35.5845 76.9722C34.9749 76.9722 34.4807 76.478 34.4807 75.8684C34.4807 75.2588 34.9749 74.7646 35.5845 74.7646C36.1941 74.7646 36.6882 75.2588 36.6882 75.8684Z"
        fill="#E0DFE6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M88.5 44.5C88.5 68.8005 68.8005 88.5 44.5 88.5C20.1995 88.5 0.5 68.8005 0.5 44.5C0.5 20.1995 20.1995 0.5 44.5 0.5C68.8005 0.5 88.5 20.1995 88.5 44.5ZM44.5 82.5C65.4868 82.5 82.5 65.4868 82.5 44.5C82.5 23.5132 65.4868 6.5 44.5 6.5C23.5132 6.5 6.5 23.5132 6.5 44.5C6.5 65.4868 23.5132 82.5 44.5 82.5Z"
        fill="#E0DFE6"
      />
    </svg>
  );
}
